import axiosapi from "./axiosAPI";

// Get All Categories
export const getAllCategories = async (
    setCategories,
    setFetcherror,
) => {
    
	try{
		const res =await axiosapi.get("/categories");
        setCategories(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Categories");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Categories");
		}
		
	}
	
};



// Get All Categories Per Country
export const getBroadCategoryCategories = async (
    setCategories,
    setFetcherror,
    pkid
) => {
    
	try{
		const res =await axiosapi.get(`/broadcategorycategories/${pkid}`);
        setCategories(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Categories");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Categories");
		}
		
	}
	
};



// Get One Category
export const getOneCategory = async (
    pkid,
    setFetcherror,  
    setCategory
    
)=>{
	try{
		const res =await axiosapi.get(`/categories/${pkid}`);
        setCategory(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Category");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Category");
		}
		
	}
	
};


// Create New Category
export const createCategory = async (
    category,
    broadcategory_id,
    setCategory,
    setFetcherror,
    handleAllToasts,
    setCategories

) => {

    if (!category || !broadcategory_id) {
        handleAllToasts(2, "No Category Provided or BroadCategory not Selected"); 
            return; 
        }

    const PushItem = {
        name: category,
        broadcategory_id:broadcategory_id
        };

    try{
        await axiosapi.post("/categories/",PushItem );
        setCategory("");
        handleAllToasts(1, "Category Created Successfully");
        getAllCategories(setCategories,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Category");
            handleAllToasts(2, "Could Not update The Category");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Category");
            handleAllToasts(2, "Could Not update The Category");
            
        }
        
    }
    
}


// Edit Existing Category

export const editCategory = async (
    pkid,
    category,
    setCategory,
    setFetcherror,
    handleAllToasts,
    setCategories
              
        ) => {

            if (!category) {
                handleAllToasts(2, "No Category Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:pkid,
                    name: category,
                };

            try{
                await axiosapi.patch("/categories/",PushItem );
                setCategory("");
                handleAllToasts(1, "Category Updated Successfully");
                getAllCategories(setCategories,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Category");
                    handleAllToasts(2, "Could Not Update Category");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Category");
                    handleAllToasts(2, "Could Not Update Category");
                    
                }
                
            }
            
};



// Delete Existing Category.

export const deleteCategory = async (
    pkid,
    setcountries,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/categories/${pkid}`);
        let finalData = res.data.message;
        getAllCategories(setcountries, setFetcherror);
        handleAllToasts(1, "Category Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Category");
            handleAllToasts(2,"Error: Could Not Delete Category");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Category");
            handleAllToasts(2,"Error: Could Not Delete Category");
		}
		
	}
	
};